import { useNavigate } from "react-router-dom";
import checkMark from "../../../assets/check-mark.png";
import functions from "../../../util/functions";

const CardItem = ({ product, productInfo = {} }) => {
	// Definindo valores padrão para productInfo
	const { features = [], warning = "" } = productInfo;
	const navigate = useNavigate();

	return (
		<div className="flex flex-col h-full bg-white rounded-2xl overflow-hidden transition-all duration-300">
			{/* Header do Card */}
			<div className="p-6 text-center border-b border-gray-100 flex-grow-0">
				<h3 className="text-xl font-bold text-gray-900 mb-2">{product.nome}</h3>
				<span className="text-sm font-medium text-gray-500 uppercase tracking-wide">A partir de</span>
				<div className="mt-2 flex items-baseline justify-center gap-1">
					<span className="text-4xl font-extrabold text-blue-700">
						{functions.strToCurrency(product.valor)}
					</span>
					<span className="text-sm font-medium text-gray-500">/mês</span>
				</div>

				<button
					className="w-full mt-6 bg-blue-600 hover:bg-blue-700 text-white font-semibold py-3 px-4 rounded-xl shadow-md transition-all hover:-translate-y-0.5"
					onClick={() => navigate(`/register-new-store/${product.id_produto}`)}
				>
					Teste Grátis
				</button>
			</div>

			{/* Features / Benefícios */}
			<div className="p-6 flex-grow bg-gray-50/50">
				<ul className="space-y-4">
					{features.map((text, index) => (
						<li key={index} className="flex items-start gap-3">
							<img src={checkMark} alt="check" className="w-5 h-5 object-contain flex-shrink-0 mt-0.5" />
							<span className="text-sm text-gray-700 leading-snug">{text}</span>
						</li>
					))}
				</ul>
			</div>

			{/* Footer / Info Extra */}
			{warning && (
				<div className="p-4 bg-gray-100/80 border-t border-gray-100 text-xs text-center text-gray-500">
					{warning.includes(":") ? (
						<>
							<span className="font-semibold text-gray-700">{warning.split(":")[0]}:</span>
							{` ${warning.split(":")[1]}`}
						</>
					) : (
						warning
					)}
				</div>
			)}
		</div>
	);
};

export default CardItem;
